// Function to get a cookie value by name
export function getCookieValue(cookieName: string): string | null {
    // Split document.cookie into an array of individual cookies
    const cookies = document.cookie.split(';');

    // Iterate through the array to find the cookie with the specified name
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const cookieParts = cookie.split('=');

        // Trim leading and trailing white spaces
        const name = cookieParts[0].trim();
        const value = cookieParts.slice(1).join('=').trim();

        // Check if the current cookie matches the specified name (case-insensitive)
        if (name.toLowerCase() === cookieName.toLowerCase()) {
            // Decode and return the cookie value
            return decodeURIComponent(value);
        }
    }

    // If the cookie with the specified name is not found, return undefined
    return null;
}

// Function to set a cookie with a given name, value, and options
export function setCookie(name: string, value: string): void {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1);
    document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
}

// Function to remove a cookie by name
export function removeCookie(name: string): void {
    document.cookie = encodeURIComponent(name) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
}
